import FindOrderField from "components/FindOrderField/FindOrderField"
const ErrorPage = () => {
  return (
    <FindOrderField />
  )
}

export default ErrorPage